import React, { useEffect, useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import dotenv from 'dotenv';
import { Eye } from 'react-preloading-component';

import { addDataToLocalStorage, getItemFromLocalStorage } from './utils';
import Weather from './components/Weather';
import Observed from './components/Observed';
import Forecast from './components/Forecast';
import Search from './components/Search';
import Error from './components/Error';
import StyledSpinner from './styles/Spinner';

dotenv.config();

const { REACT_APP_API_KEY } = process.env;

const App = () => {
  const [observedWeather, setObservedWeather] = useState({});
  const [forecastWeather, setForecastWeather] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((success) => {
        const data = getItemFromLocalStorage(
          'currentLocation',
          'currentLocation'
        );
        if (data) {
          setForecastWeather(data.forecast);
          setObservedWeather(data.observed);
          setLoading(false);
        } else {
          let fiveDaysAgo = moment().subtract(4, 'd').format('YYYY-MM-DD');
          fiveDaysAgo = moment(fiveDaysAgo).format('X');
          let { latitude, longitude } = success.coords;
          longitude = parseFloat(longitude.toFixed(7));

          const observedURL = `https://api.openweathermap.org/data/2.5/onecall/timemachine?lat=${latitude}&lon=${longitude}&dt=${fiveDaysAgo}&units=metric&appid=${REACT_APP_API_KEY}`;
          const forecastURL = `https://api.openweathermap.org/data/2.5/forecast?q=lagos&units=metric&appid=${REACT_APP_API_KEY}`;

          axios
            .get(observedURL)
            .then((res) => {
              setObservedWeather(res.data);
              axios
                .get(forecastURL)
                .then((response) => {
                  setForecastWeather(response.data);
                  const data = {
                    observed: res.data,
                    forecast: response.data,
                  };

                  addDataToLocalStorage(
                    data,
                    'currentLocation',
                    'currentLocation'
                  );
                })
                .catch(() => setError('Unable to load location details'));
            })
            .catch(() => setError('Unable to load location details'))
            .finally(() => setLoading(false));
        }
      });
    }
    setLoading(false);
  }, []);

  const onKeyPress = (searchValue, lat = 0, lon = 0) => {
    setError('');
    setLoading(true);
    const cachedData = getItemFromLocalStorage(searchValue, searchValue);
    if (cachedData) {
      setForecastWeather(cachedData.forecast);
      setObservedWeather(cachedData.observed);
      setLoading(false);
    } else {
      const URL = `https://api.openweathermap.org/data/2.5/forecast?q=${searchValue}&appid=${REACT_APP_API_KEY}`;
      let latitude = lat;
      let longitude = lon;
      axios
        .get(URL)
        .then((res) => {
          setForecastWeather(res.data);

          if (lat === 0 && lon === 0) {
            const {
              city: {
                coord: { lat, lon },
              },
            } = res.data;

            latitude = lat;
            longitude = lon;
          }

          let fiveDaysAgo = moment().subtract(4, 'd').format('YYYY-MM-DD');
          fiveDaysAgo = moment(fiveDaysAgo).format('X');
          const observedURL = `https://api.openweathermap.org/data/2.5/onecall/timemachine?lat=${latitude}&lon=${longitude}&dt=${fiveDaysAgo}&units=metric&appid=${REACT_APP_API_KEY}`;

          axios
            .get(observedURL)
            .then((response) => {
              const data = {
                observed: response.data,
                forecast: res.data,
              };
              addDataToLocalStorage(data, searchValue, searchValue);

              setObservedWeather(response.data);
            })
            .finally(() => setLoading(false));
        })
        .catch(() => {
          setError(`Unable to retrieve location details for "${searchValue}"`);
        });
    }
  };

  if (error) {
    return (
      <>
        <Search onKeyPress={onKeyPress} />
        {error ? <Error error={error} /> : ''}
      </>
    );
  }

  let searchResponse = '';
  if (
    Object.values(observedWeather).length > 0 &&
    Object.values(forecastWeather).length > 0
  ) {
    searchResponse = (
      <>
        <div>
          <Weather
            currentWeather={observedWeather.current}
            timezone={`${forecastWeather.city.name}/${forecastWeather.city.country}`}
          />
          <Observed hourly={observedWeather.hourly} />
          <Forecast forecast={forecastWeather} />
        </div>
      </>
    )
  }

  return (
    <>
      <Search onKeyPress={onKeyPress} />
      {error ? <Error error={error} /> : ''}
      {loading ? (
        <StyledSpinner>
          <Eye color='#ffffff' size='25' />
        </StyledSpinner>
      ) : (
        searchResponse
      )}
    </>
  );
};

export default App;
